<template>
    <TintForm :tint="tint" v-if="loaded" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import TintForm from './TintForm.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    TintForm
  },
  data() {
    return {
      tint:null,
      loaded:false,
    }
  },
  methods:{
    
  },
  async mounted()
  {
    this.tint=await APIRequest.detail('tints',this.$route.params.id)
    this.loaded=true
  }
}
</script>
